<template>
  <el-dialog :close-on-click-modal="false" title="收选片模板" :visible.sync="isShow" :width="$route.query.type === 'check' ? '1300px' : '1000px'">
    <el-form :inline="true" :model="vo">
      <el-form-item label="模板名称" style="float:left;margin-left: 5px;">
        <el-input v-model="vo.name" placeholder="模板名称"></el-input>
      </el-form-item>
      <el-form-item label="模板主题">
        <el-select v-model="vo.themeId" placeholder="模板主题">
          <el-option v-for="item in themeList" :key="item.themeId" :label="item.themeName" :value="item.themeId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板类型" style="float:left;margin-left: 5px;">
        <el-select v-model="vo.region" placeholder="模板类型">
          <el-option v-for="(k, v) in $config.templateType" :key="v" :label="k" :value="v"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联尺寸组" :class="$route.query.type === 'check' ? 'relation' : ''">{{ vo.composeSizeGroupName }}</el-form-item>
      <el-form-item style="float:right;margin-right: 10px;">
        <el-button round @click="getTemplateList()">查询</el-button>
        <el-button v-show="!isAdd" type="primary" round @click="isAdd = true, getTemplateList()">添加关联</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column label="模板名称" prop="name"></el-table-column>
      <el-table-column label="模板主题" prop="themeName"></el-table-column>
      <!-- <el-table-column label="是否关联尺寸组" prop="isAssociatedeSizeGroup">
        <template slot-scope="scope">
          {{scope.row.isAssociatedeSizeGroup?'是':'否'}}
        </template>
      </el-table-column> -->
      <el-table-column label="尺寸组" prop="groupName"></el-table-column>
      <el-table-column label="模板类型" prop="themeName">
        <template slot-scope="scope"> {{ $config.templateType[scope.row.templateType] }} </template>
      </el-table-column>
      <el-table-column label="模板页数量" prop="moduleNum"></el-table-column>
      <el-table-column label="模板页P数" prop="pageNum"></el-table-column>
      <el-table-column prop="skuMainImage" label="模板主图">
        <template slot-scope="scope">
          <!-- <img style="width:100%" :src="scope.row.skuMainImage" alt="" v-if="scope.row.skuMainImage">
                <span class="color-blue" v-else>上传主图</span> -->
          <div style="width:100%;position:relative;" v-if="scope.row.skuMainImage">
            <img style="width:100%" :src="scope.row.skuMainImage" alt="">
            <i class="el-icon-circle-close" style="color:#F56C6C;position:absolute;top:2px;right: 2px;z-index: 999;font-size: 18px;" @click="scope.row.skuMainImage = ''"></i>
          </div>
          <div class="upload-img" v-if="!scope.row.skuMainImage">
            <input type="file" name="" id="input_img" @change="fileSize($event, scope.row)" />
            <span class="color-blue">上传主图</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span class="color-blue" @click="$refs.setExample.show(scope.row.templateId, false)">查看示例<br></span>
          <span class="color-blue" v-show="isAdd && !scope.row.templateSkuXrefId" @click="add(scope.row)">关联</span>
          <span class="color-blue" v-show="!isAdd || (isAdd && scope.row.templateSkuXrefId)" @click="cancel(scope.row)">取消关联<br></span>
          <span class="color-blue" v-show="scope.row.templateType === 'ORDER' && scope.row.isDefault === 0" @click="setDefault(1, scope.row)">设为默认模板</span>
          <span class="color-blue" v-show="scope.row.templateType === 'ORDER' && scope.row.isDefault === 1" @click="setDefault(0, scope.row)">取消默认模板</span>
        </template>
      </el-table-column>
    </el-table>
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <setExample ref="setExample" />
    <!-- 错误提示 -->
    <el-dialog :close-on-click-modal="false" title="错误提示" :modal-append-to-body="false" :visible.sync="deleteSkuDialog" width="30%">
      <p>{{ text }}</p>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="deleteSkuDialog = false">取 消</el-button> deleteSku()-->
        <el-button type="primary" @click="deleteSkuDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import VPagination from '@/components/Pagination/index'

import setExample from '@/views/PickCollAdmin/template/setExample.vue'
import { templatePage, themeList, templatePageBySkuId, skuRelationTemplate, skuRemoveTemplate, setOrderDefault, updateSkuMainImage } from '@/api/auxx.js'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  components: {
    setExample, VPagination
  },
  data () {
    return {
      isPdf: false, // 是否是PDF产品 
      isShow: false,
      isAdd: false,
      vo: {
        composeSizeGroupId: '',
        name: '',
        skuId: '',
        templateType: '',
        themeId: '',
        composeSizeGroupName: '',
        maxPage: ''
      },
      tableData: [],
      themeList: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      deleteSkuDialog: false,
      multipleSelection: [],
      text: ''
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getThemeList()
  },
  methods: {
    // 上传主图
    fileSize (data, row) {
      let id = row.templateId
      let xrefId = row.templateSkuXrefId || row.id
      let file = data.target.files[0]
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          if (width === height) {
            _this.upload(file, id, xrefId)
          } else {
            _this.$message.error('图片长宽不相同')
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传图片
    upload (file, id, xrefId) {
      console.log('fileType', file.type)
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return
      }
      if (file.size > 1024 * 1024 * 1) {
        this.$message.error('图片大小不能超过1M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(async res => {
        console.log('xrefId', xrefId)
        if (xrefId) {
          await updateSkuMainImage({
            skuMainImage: res,
            id: xrefId
          })
        }
        let skuList = this.tableData.map(element => {
          if (element.templateId === id) {
            return {
              ...element,
              skuMainImage: res
            }
          } else {
            return element
          }
        })
        this.tableData = skuList
        console.log('this.templateGroupMsg.skuList', this.tableData)
        // this.$forceUpdate()
      })
    },
    show (skuId, composeSizeGroupId, composeSizeGroupName, maxPage, isPdf) {
      this.isPdf = isPdf
      this.vo.skuId = skuId
      this.vo.composeSizeGroupId = composeSizeGroupId
      this.vo.composeSizeGroupName = composeSizeGroupName
      this.vo.maxPage = maxPage

      this.isAdd = false
      this.isShow = true

      this.getTemplateList()
      console.log(this.vo.composeSizeGroupName)
    },
    cancel (row) {
      console.log(row)
      this.isAdd = false
      let list = [row.id]
      skuRemoveTemplate(list)
        .then(res => {
          if (res.data.success) {
            this.$message.success('取消成功')
            this.getTemplateList()
          }
        })
    },
    add (row) {
      console.log('模板', row)
      if (!row.skuMainImage) {
        this.$message.warning('请上传模板主图')
        return
      }
      if (this.vo.maxPage > row.pageNum && row.templateType !== 'COMMON' && !this.isPdf) {
        this.text = '模板页数量应大于等于sku的最大P数'
        this.deleteSkuDialog = true
      } else {
        skuRelationTemplate({
          skuId: this.vo.skuId,
          templateId: row.templateId,
          templateType: row.templateType,
          skuMainImage: row.skuMainImage
        })
          .then(res => {
            if (res.data.success) {
              this.$message.success('关联成功')
              this.isAdd = false
              this.getTemplateList()
            }
          })
      }
    },
    // 设置默认
    setDefault (act, val) {
      setOrderDefault(val.id, act).then(res => {
        console.log(res)
        if (res.data.success) {
          this.$message.success('设置成功')
          this.getTemplateList()
        }
      })
    },
    getTemplateList () {
      let vo = Object.fromEntries(Object.entries(this.vo).map(([key, value]) => [key, value === '' ? null : value]))
      console.log('vo', vo)
      if (this.isAdd) {
        // vo.skuId = ''
        templatePage({
          params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
          vo: vo
        })
          .then(res => {
            if (res.data.success) {
              let list = res.data.data.content
              list.forEach(item => {
                let str = []
                item.templateModuleXrefs.forEach(module => {
                  str.push(module.module.name)
                })
                item.moduleNameStr = str.join(', ')
              })
              this.tableData = list.map(itm => {
                return {
                  ...itm,
                  groupName: itm.composeSizeGroup.groupName
                }
              })
              this.queryInfo.total = res.data.data.total
            }
          })
      } else {
        templatePageBySkuId({
          params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
          vo: vo
        })
          .then(res => {
            if (res.data.success) {
              let list = res.data.data.content

              this.tableData = list
              this.queryInfo.total = res.data.data.total
            }
          })
      }
    },
    getThemeList () {
      themeList()
        .then(res => {
          if (res.data.success) {
            this.themeList = res.data.data
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.getTemplateList()
    }
  }
}
</script>

<style>
.relation {
  position: absolute;
  left: -75px;
  margin-top: 30px;
}
</style>
